import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import GoogleAdsCard from './GoogleAdsCard';
const GoogleAdsCards = ({ googleAds, stats, period }) => {
  const fetch = useFetch();
  const [loadError, setLoadError] = useState();
  const [allStatuses, setAllStatuses] = useState([]);

  const { accountId, domainId } = useParams();
  const googleAccount = useSelector((state) => state.google.account);

  const customerId = googleAccount?.adAccountId;
  const resourceNames = useMemo(
    () =>
      googleAds
        ?.map((ad) => ad.resourceName)
        .filter(Boolean)
        .filter((resourceName) => resourceName.includes(customerId)),
    [customerId, googleAds]
  );

  useEffect(() => {
    if (customerId && resourceNames.length > 0) {
      const fetchData = async () => {
        try {
          const { primaryStatusAndReason } = await fetch(
            `/api/admin/accounts/${accountId}/domains/${domainId}/google/${customerId}/ads/statuses`,
            {
              method: 'POST',
              body: JSON.stringify({ resourceNames }),
            }
          );
          setAllStatuses(primaryStatusAndReason);
        } catch (error) {
          setLoadError(error);
        }
      };

      fetchData();
    }
  }, [fetch, accountId, domainId, customerId, resourceNames]);

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  return googleAds.map((ad) => {
    let resourceName = ad?.resourceName || undefined;

    const statuses = allStatuses?.find((s) => s.campaign.resourceName === resourceName);
    return (
      <GoogleAdsCard
        key={uuidv4()}
        googleAd={ad}
        stats={stats}
        period={period}
        statuses={statuses ? statuses : undefined}
      />
    );
  });
};

export default GoogleAdsCards;
